<template>
<div>
    <div class="form-row align-items-center">
      <div class="col-sm-3 my-1 form-group">
        <select
                v-model="birth_date.date"
                id="date"
                class="form-control"
              >
              <option disabled value="">วันที่</option>
              <option v-for="i in days"  v-bind:value="i"  v-bind:key="i">
                {{i}}
              </option>
              </select>
         
         <select
                v-model="birth_date.month"
                id="month"
                class="form-control"
              >
              <option disabled value="">เดือน</option>
              <option v-for="({key,txt}, index) in month"  v-bind:value="key"  v-bind:key="index">
                {{txt}}
              </option>
              </select>

         <select
                v-model="birth_date.year"
                id="year"
                class="form-control"
              >
              <option disabled value="">ปี</option>
              <option v-for="i in year"  v-bind:value="i"  v-bind:key="i">
                {{i}}
              </option>
              </select>
      </div>
    </div>
</div>
</template>
<script>
  import {DateTimeFunc} from "../libs/constant";
  export default{
    props:{
        birthDate:{
            type: String,
          }
      },
    data(){
        return {
          birth_date: {
              date:"",
              month: "", 
              year:"",
            }
          }
      },
     computed:{
          currentYear(){
              return new Date().getFullYear();
            },
          month(){
              return DateTimeFunc.MONTH();
            },
          year(){
              return DateTimeFunc.YEAR();
            },
          days(){
              return DateTimeFunc.DAYS();
            },
          
          
       },
     mounted(){
        console.log(this.birthDate);
        let bd = this.birthDate.split("-");
        console.log(bd);
        //let bd = bdt[0].split("-");
        this.birth_date.date = bd[2];
        this.birth_date.month = bd[1];
        this.birth_date.year = bd[0];
        console.log(this.birth_date);
        //console.log(this.currentYear);
        //console.log(this.month);
        //console.log(this.year);
       }
   }
</script>